export default {
  dashboardv2: {
    allTime: "Wakati Wote",
    averageSellingPriceByAllFarmers: "Bei ya Kuuza Wastani na Wakulima Wote",
    avgSellingPrice: "Bei ya Kuuza Wastani",
    avgSellingPricePerFarmer: "Bei ya Kuuza Wastani kwa Kila Mkulima",
    buyingStationProduction: "Uzalishaji wa Kituo cha Kununua",
    dryMillingProduction: "Uzalishaji wa Kusaga Kavu",
    expiryDate: "Tarehe ya Mwisho",
    exportAsCSV: "Hamisha Kama CSV",
    exportAsXLS: "Hamisha Kama XLS",
    farmerName: "Jina la Mkulima",
    farmerProduction: "Uzalishaji wa Mkulima",
    gender: "Jinsia",
    noOfUsers: "Idadi ya Watumiaji",
    plan: "Mpango",
    planType: "Aina ya Mpango",
    planValidity: "Uhalali wa Mipango",
    pricePaid: "Bei Iliyolipwa",
    production: "Uzalishaji",
    users: "Watumiaji",
    usersByGender: "Watumiaji kwa Jinsia",
    usersByStatus: "Watumiaji kwa Hali",
    usersPerMembershipPlans: "Watumiaji kwa Kila Mpango wa Uanachama",
  },
  dashboardSection: {
    greenBeansData: "Usimamizi wa Maharage ya Kijani",
    greenCoffee: "Kahawa Ijani",
    dryMilling: "Kusaga Kavu",
    modules: "Moduli",
    allowances: "Posho",
    maxUserAllowed: "Upeo wa Watumiaji Unaoruhusiwa ",
    satelliteReportsAllowed: "Ripoti za Setilaiti Zinaruhusiwa ",
    advanceReport: "Ripoti za Kina Zinaruhusiwa ",
    subscriptionUpTo: "Usajili Hadi",
    roleAllowed: "Majukumu Yanayoruhusiwa ",
    moduleAllowed: "Moduli Zinazoruhusiwa ",
    registeredUsers: "Watumiaji Waliosajiliwa",
    validMemberships: "Uanachama Halali",
    activeUsers: "Watumiaji Hai",
    deactivatedUsers: "Watumiaji Waliozimwa",
    membershipValidity: "Uhalali wa Uanachama",
    lessThan1Month: "Chini ya Mwezi 1",
    months1to6: "Miezi 1-6",
    months6to12: "Miezi 6-12",
    moreThan1Year: "Zaidi ya mwaka 1 ",
    cropOverview: "Muhtasari wa mazao",
    plantations: "Mashamba ",
    coffeeData: "Data ya Kahawa",
    availableModules: "Moduli Zinazopatikana",
    roleList: "Mkulima, Kituo cha Kununulia, Ghala",
    memberData: "Data ya Mwanachama",
    userType: "Aina ya Mtumiaji",
    registered: "Imesajiliwa",
    offlineUsers: "Watumiaji Hawapo Mtandaoni",
    lessThanOneMonth: "< 1 Mwezi",
    cacaoData: "Data ya Kakao",
    dryCacao: "Kakao Kavu",
    traceability: "Ufuatiliaji",
  },
  greenBeansData: {
    notFound: "Hakuna data iliyopatikana",
  },
  dashboardReports: {
    appDataReports: "Ripoti za Data ya Programu",
    reports: "Ripoti",
    soilNutrients: {
      carbon: "Kaboni",
      potassium: "Potasiamu",
      phosphorus: "Fosforasi",
      nitrogen: "Naitrojeni",
      sulfur: "Salfa",
    },
  },
};
